import React, { useEffect, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import HomePage from "./pages/HomePage";
import { Routes, Route } from "react-router-dom";
import TopHeader from "./components/TopHeader/TopHeader";
import Header from "./components/Header/Header";
import BurgerMenu from "./components/BurgerMenu/BurgerMenu";
import { Suspense } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Footer from "./components/Footer/Footer";
// import { BackToTop } from "./BackToTop.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import Robiya from "./pages/Project/Robiya";
import Kamron from "./our_teacher/kamron/Kamron";
import ScrollToTop from "./ScroleOn";
import Lesson from "./components/lesson/Lesson";
import Qamchiyev from "./our_teacher/qamchiyev/Qamchiyev";
const MainProject = React.lazy(() => import("./pages/Project/MainProject"));
const SingleNews = React.lazy(() => import("./pages/news/SingleNews"));
const SingleProject = React.lazy(() => import("./pages/Project/SingleProject"));
const News = React.lazy(() => import("./pages/news/News"));
const Contact = React.lazy(() => import("./pages/contact/Contact"));
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

//this is my firth project
const App = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [close, open] = useState(false);
  const handleLoading = () => {
    setIsLoading(false);
  };
  useEffect(() => {
    window.addEventListener("load", handleLoading);
    return () => window.removeEventListener("load", handleLoading);
  }, []);
  const map = [
    { id: 1, url: "news", kompannent: <News /> },
    { id: 2, url: "shermuhammad", kompannent: <SingleNews /> },
    { id: 3, url: "teacher", kompannent: <Contact close={close} /> },
    { id: 4, url: "education", kompannent: <MainProject /> },
    { id: 5, url: "teacher/shermuhammad", kompannent: <SingleProject open={open} /> },
    { id: 6, url: "teacher/robiya", kompannent: <Robiya open={open} /> },
    { id: 7, url: "teacher/kamron", kompannent: <Kamron open={open} /> },
    { id: 7, url: "teacher/kamron_1", kompannent: <Qamchiyev open={open}/> },
    { id: 9, url: "lesson", kompannent: <Lesson close={close} /> },
  ];
  const mapRoute = map.map((a) => (
    <Route
      key={a.id}
      path={a.url}
      element={
        <Suspense
          fallback={
            <>
              <Backdrop className={classes.backdrop} open>
                <CircularProgress color="inherit" />
              </Backdrop>{" "}
            </>
          }
        >
          {" "}
          {a.kompannent}
        </Suspense>
      }
    />
  ));
  return (
    <div className="App">
      {isLoading ? (
        <>
          <Backdrop className={classes.backdrop} open>
            <CircularProgress color="inherit" />
          </Backdrop>{" "}
        </>
      ) : (
        <>
          <ScrollToTop />
          {/* <BackToTop /> */}
          <TopHeader />
          <BurgerMenu />
          <Header />
          <Routes>
            {mapRoute}
            <Route path="/" element={<HomePage />} />
          </Routes>
          <Footer />
        </>
      )}
    </div>
  );
};
export default App;
// Full name: Kamron Mirzakhanov
// Age: 25
// IELTS: 7.5  but already has expired (date: 17.02.2016)

// Work experience: Dubai , United Arab Emirates :
// Position: Sales associate from 2017 to 2018
// Brand name: Beverly Hills Polo Club
// Company name : Apparel L.L.C

// Work experience: Dubai , United Arab Emirates :
// Position: Visual merchandiser also store in charge from 2018 to 2021
// Brand name: Lefties
// Company name : Azadea

// Work experience: Andijan, Uzbekistan :
// Position : Manager / ESL teacher
// Company name : Andijan Development Centre.
// Currently working .

// Educational background: High school Diploma Andijan Communication technologies college.

// Current students’ quantity: 30

// Approximately 70% of them are showing spectacular improvements in their performance.

// Languages:
// English fluent
// Russian fluent
// Uzbek native
// Korean elementary

// Additional abilities: Pro video editor
